<template>
  <div>
    <template v-if="items.length > 0">
      <v-menu v-model="menu" location="bottom">
        <template v-slot:activator="{ props }">
          <div class="global-policy-selector__btn-content cursor-pointer" v-bind="props">
            <v-icon icon="$add" />
            <div class="coro-link ml-2">{{ $t(`modals.addGlobalMspPolicy.addPolicy`) }}</div>
          </div>
        </template>

        <v-card min-width="412">
          <v-card-text class="pa-0">
            <v-list select-strategy="single-leaf" class="pt-2 pb-2x">
              <v-list-item
                v-for="(item, index) in items"
                :key="index"
                :value="item.key"
                :ripple="false"
                @click="addPolicy(item)"
              >
                <v-list-item-title>
                  <div class="d-flex align-center">
                    <v-icon :icon="item.icon" />
                    <div class="ml-1">
                      {{ $t(`modals.addGlobalMspPolicy.policies.${item.key}.title`) }}
                    </div>
                  </div>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-menu>
    </template>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, type PropType, ref } from "vue";
import { GlobalPolicySection } from "@/constants/msp.ts";
export interface GlobalPolicySelectorMenuItem {
  key: GlobalPolicySection;
  icon: string;
}

export default defineComponent({
  props: {
    selectedItems: {
      type: Array as PropType<GlobalPolicySection[]>,
      required: true,
    },
  },
  emits: ["policies-updated"],
  setup(props, { emit }) {
    const menu = ref(false);

    const items = computed(() => {
      const allItems: GlobalPolicySelectorMenuItem[] = [
        {
          key: GlobalPolicySection.CLOUD_SECURITY,
          icon: "$cloudSecurityXs",
        },
        {
          key: GlobalPolicySection.DEVICE_SETTINGS,
          icon: "$settingsXs",
        },
        {
          key: GlobalPolicySection.ENDPOINT_DATA_GOVERNANCE,
          icon: "$endpointDataGovernanceXs",
        },
        {
          key: GlobalPolicySection.USER_DATA_GOVERNANCE,
          icon: "$userDataGovernanceXs",
        },
        {
          key: GlobalPolicySection.EMAIL_SECURITY,
          icon: "$mailUnreadXs",
        },
        {
          key: GlobalPolicySection.ENDPOINT_SECURITY,
          icon: "$endpointXs",
        },
        {
          key: GlobalPolicySection.EDR,
          icon: "$edrXs",
        },
      ];
      return allItems.filter((item: GlobalPolicySelectorMenuItem) => {
        return !props.selectedItems.includes(item.key);
      });
    });

    const addPolicy = (policy: GlobalPolicySelectorMenuItem) => {
      menu.value = false;
      emit("policies-updated", [...props.selectedItems, policy.key]);
    };

    return {
      menu,
      addPolicy,
      items,
    };
  },
});
</script>

<style scoped lang="scss">
.v-card {
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.12) !important;
}

.global-policy-selector__btn-content {
  display: flex;
  align-items: center;
  margin-left: 19px;
  .icon-add-xs:before {
    color: rgb(var(--v-theme-link)) !important;
  }
}
</style>
